<template>
    <div :class="$attrs.class">
        <div v-if="$page.props.flash.success" class="w-full h-16 flex items-center bg-green-600 p-2 rounded-lg text-white">
            {{ $page.props.flash.success }}
        </div>
        <div v-if="$page.props.flash.error" class="w-full h-16 flex items-center bg-red-600 p-5 rounded-lg text-white">
            {{ $page.props.flash.error }}
        </div>
    </div>
</template>


<script>
export default{
    inheritAttrs: false
}
</script>